import React, {useState, useEffect, useRef} from "react";

import {Button} from "primereact/button";
import {Toast} from "primereact/toast";
import { ProgressBar } from 'primereact/progressbar';
import { RadioButton } from 'primereact/radiobutton';
import { FileUpload } from 'primereact/fileupload';

import "./fieldStyle.scss";

export const FileUploader = ({ mimeTypes, categories, maxSize, multiUpload, emptyMsg, onValueChange, disabled, editJustifCategory}) => {

    const toast = useRef(null);
    const fileUploadRef = useRef(null);

    const [files, setFiles] = useState([]);
    const [action, setAction] = useState(null);
    const [totalSize, setTotalSize] = useState(0);
    const [selectedCategory, setSelectedCategory] = useState(categories.length > 1 ? editJustifCategory : categories[0]);

    useEffect(() => {
        if(files?.length > 0 || action === 2){
            onValueChange(files);
            if(categories.length > 1) setSelectedCategory(null);
            setAction(null);
        }
    }, [files]);


    const disableButton = () => {
        if(!selectedCategory || (!multiUpload && files.length > 0)) return 'p-disabled';
    };

    const chooseOptions = { label: 'Ajouter', className: disableButton() };
    const cancelOptions = { label: 'Annuler' };

    const defaultEmptyMsg = 'Sélectionnez un fichier ou glissez-le ici';

    const formatSize = (bytes) => {
           if (bytes === 0) {
                  return '0 MB';
                }

                var k = 10,
                    dm = 2;
           return parseFloat((bytes / Math.pow(k, 6)).toFixed(2)) + ' MB';
    };

    const headerTemplate = (options) => {
        const { className, chooseButton } = options;
        const value = totalSize/100000;
        const formatedValue = fileUploadRef && fileUploadRef.current ? formatSize(totalSize) : '0 B';
        const formatedMaxValue = maxSize/1000000;

        return (
            <div className={className} style={{backgroundColor: 'transparent', display: 'flex', alignItems: 'center'}}>
                {chooseButton}
                <p style={{verticalAlign: 'middle', margin: 0, wordBreak: 'break-word'}}>({ mimeTypes.map(item => item.split('/')[1]).join(', ') })</p>
                <ProgressBar value={value} displayValueTemplate={() => `${formatedValue} / ${formatedMaxValue} MB`} ></ProgressBar>
            </div>
        );
    };

    const itemTemplate = (file, props) => {
        if (mimeTypes.includes(file.type)) {
            return (
                <div className="flex align-items-center flex-wrap">
                    <div className="flex align-items-center" style={{ width: "90%" }}>
                        <img
                            alt={file.name}
                            role="presentation"
                            src={mapFileIcon(file.type)}
                            width={70}
                            style={{ width: "40px" }}
                        />
                        <div className="flex flex-column">
                            <div className="file-text flex flex-column text-left ml-3 font-bold" style={{ color: '#1769aa' }}>{file.category}</div>
                            <div className="file-text flex flex-column text-left ml-3" style={{ borderStyle: 'solid', borderWidth: '.5px', borderBottom: 'none', color: '#424242', margin: '2px 0 2px 0' }}></div>
                            <div className="file-text flex flex-column text-left ml-3 fit-width-40" style={{ color: '#424242' }}>{file.name}</div>
                        </div>
                    </div>
                    <Button
                        type="button"
                        icon="pi pi-times"
                        className="p-button-outlined p-button-rounded p-button-danger ml-auto"
                        onClick={() => onRemove(file, props.onRemove)}
                        title="Supprimer le document"
                    />
                </div>
            );
        } else {
            displayError('Extension du fichier non supportée.');
            onRemove(file, props.onRemove);
        }
    };

    const mapFileIcon = (mime) => {
        switch (mime) {
            case 'application/pdf':
                return '/assets/image/PDF.png';
            case 'image/jpg':
            case 'image/jpeg':
            case 'image/png':
                return '/assets/image/GIF.png';
            default:
                return;
        }
    }

    const emptyTemplate = () => {
        return (
            <div className="flex align-items-center justify-content-center flex-row">
                <i className="pi pi-cloud-upload p-clickable"
                   style={{ fontSize: "3em", borderRadius: "50%", padding: ".2em", color: "rgb(70,77,78)" }} />
                <span style={{ color: "rgb(70,77,78)", margin: "0rem !important" }} className="my-5 p-clickable">
                    <b>{ emptyMsg ? emptyMsg : defaultEmptyMsg }</b>
                </span>
            </div>
        );
    };

    const onBeforeSelect = (e) => {
        const tmpFiles = e.originalEvent.target.files ? e.originalEvent.target.files : e.originalEvent.dataTransfer.files;
        if(!selectedCategory) {
            displayError('Veuillez sélectionner un type de justificatif avant d\'ajouter un document.');
            return false;
        } else if(invalidMimeType(tmpFiles)) {
            displayError('Extension du fichier non supportée.');
            return false;
        } else if(calculateTotalSize(tmpFiles) > maxSize) {
            displayError('Les documents dépassent la limite de taille autorisée.');
            return false;
        }
    };

    const invalidMimeType = (eFiles) => {
        let invalid = false;
        Object.values(eFiles).forEach(file => {
            if(!mimeTypes.includes(file.type)) {
                invalid = true;
                return;
            }
        });
        return invalid;
    }

    const onSelect = (e) => {
        let tmpFiles = [];
        const category = { key: selectedCategory.key, value: selectedCategory.value };
        Object.values(e.files).forEach((file, index) => {
            if((files.length === 0) || !isFileExists(file)) {
                const newState = {
                    category: [category.key, category.value],
                    file: file
                };
                setFiles(prevState => [...prevState, newState]);
                tmpFiles.push(file);
                file.category = category.value;
            }
        });
        setTotalSize(calculateTotalSize(tmpFiles));
    };

    const isFileExists = (file) => {
        let exists = false;
        Object.values(files).forEach(el => {
            if(el.file.name === file.name) {
                exists = true;
                displayError('Le fichier ' + file.name + ' a déjà été sélectionné.');
            };
            return;
        });
        return exists;
    }

    const calculateTotalSize = (tmpFiles) => {
        let _totalSize = totalSize;
        Object.values(tmpFiles).forEach(file => {
            _totalSize += file.size;
        });
        return _totalSize;
    }

    const onRemove = (file, callback) => {
        setAction(2);
        setFiles(prevState => (prevState.filter(item => item.file !== file)));
        setTotalSize(totalSize - file.size);
        callback();
    };

    const showErrorValidationFile = (e) => {
        toast.current.show({
            severity: "error",
            summary: "ERREUR",
            detail:
                e.err,
            life: 5000,
        });
    };

    const displayError = (message) => {
        toast.current.show({
            severity: "error",
            summary: "ERREUR",
            detail: message,
            life: 5000,
        });
    }

    return (
        <div>
            <Toast ref={toast} position="top-center" className="toast-position" />
            <div className="fileupload-radio col-12">
                {
                    categories && categories.map((category, index) => {
                        return (
                        <div>
                            <div key={index} className="field-radiobutton">
                                <RadioButton inputId={index} name="category" value={category} onChange={(e) => setSelectedCategory(e.value)} checked={categories.length === 1 || selectedCategory &&  selectedCategory === category} />
                                <label className="form-block-info" htmlFor={index}><b>{category.value}</b></label>
                            </div>
                            {category.description && <ul className="form-block-info" >
                                <li>
                                 {category.description}
                                 </li>
                            </ul>}
                        </div>
                        )
                    })
                }
            </div>
            <FileUpload
                ref={fileUploadRef}
                name="justificatif[]"
                accept={mimeTypes.join()}
                maxFileSize={maxSize}
                multiple={multiUpload}
                headerTemplate={headerTemplate}
                chooseOptions={chooseOptions}
                cancelOptions={cancelOptions}
                onValidationFail={showErrorValidationFile}
                onBeforeSelect={onBeforeSelect}
                // onBeforeDrop={onBeforeSelect}
                onSelect={onSelect}
                onDrop={onSelect}
                emptyTemplate={emptyTemplate}
                itemTemplate={itemTemplate}
                disabled={disabled}
                invalidFileSizeMessageSummary={'{0}: La taille du fichier est non conforme.'}
                invalidFileSizeMessageDetail={'La taille maximal autorisé est de ' + maxSize/1000000 + ' MB.'}
            />
        </div>
    )
}
